import { FC } from 'react';
import { AdvertContactDataItemType } from '@edikk-edikk/country-frontend';
import advertDetailContactItemCss from '../../assets/contacts/contact-item.module.scss';
import { AdvertSocialLink } from '#components/social-link';

type PropsType = {
  socialLink: AdvertContactDataItemType;
};

const ContactsSocialLink: FC<PropsType> = ({
  socialLink,
}) => (
  <div className={advertDetailContactItemCss.advertDetailContactItem}>
    <AdvertSocialLink
      socialLink={socialLink}
      buttonAdditionalClassName={advertDetailContactItemCss.advertDetailContactItem__link}
    />
  </div>
);

export { ContactsSocialLink };
